module.exports = __webpack_public_path__ + "img/gonetwork2_7.14c4155a.png";